export default __webpack_public_path__ + "static/media/CNo.64-3.1bb61097.jpg";